// 讨论与日志用混入
export default {
  data () {
    return {
      currentPreviewImgUrl: [],
      currentPreviewImgUrlSrc: '',
      archivedColumns: [],
      formValue: {
        newValue: null,
        oldValue: null
      }
    }
  },
  methods: {
    compareNumString (val, oldVal) {
      if (typeof val === 'number' && String(val) === oldVal) {
        return true
      }
      return this.$_.isEqual(val, oldVal)
    },
    getFileContent (val) {
      if (!val) {
        return ''
      }
      let fileArray = String(val).split('$.$')
      let content = ''
      fileArray.forEach((f, index) => {
        if (f) {
          content += `${f.split(',/')[0]}${index === fileArray.length - 1 ? '' : '，'}`
        }
      })
      return content
    },
    handleFileContent (changeObj) {
      // fixme: 依赖值以$.$开头来判断是否文件不严谨
      if ((String(changeObj.old) && String(changeObj.old).startsWith('$.$')) || (String(changeObj.new) && String(changeObj.new).startsWith('$.$'))) {
        changeObj.old = this.getFileContent(changeObj.old)
        changeObj.new = this.getFileContent(changeObj.new)
      }
      return changeObj
    },
    getArchivedColumns (tableId) {
      if (tableId) {
        this.$axios.get(`/data-api/table/${tableId}`)
          .then(res => {
            // 因为上面的 table 是克隆出来的的, 对其进行修改不会改变 options 里面的东西, 所以在这里重新查询一下
            this.archivedColumns = res.data.columns
          })
      }
    },
    getDifferenceBetweenObj (object, base) {
      let _this = this
      function changes (object, base) {
        // 注意这里内部的循环调用 this 指向了window，严格模式下undefined
        // 将对象通过处理函数转换为新的 acc 对象
        return _this.$_.transform(object, function (result, value, key) {
          // 如果不等则放入最终不等的对象， 如果是对象则深入比较
          if (!_this.$_.isEqualWith(value, base[key], _this.compareNumString)) {
            result[key] = (_this.$_.isObject(value) && _this.$_.isObject(base[key])) ? changes(value, base[key]) : {new: value, old: base[key]}
          }
        })
      }
      return changes(object, base)
    },
    getDiffInNewValue () {
      return new Promise(resolve => {
        let content = ''
        let asyncChildrenArray = []
        if (this.formValue.newValue && this.formValue.oldValue) {
          let changeObj = this.getDifferenceBetweenObj(this.formValue.newValue, this.formValue.oldValue)
          Object.keys(changeObj).forEach(async (key, index) => {
            if (!Array.isArray(changeObj[key])) {
              let archiveColumn = this.archivedColumns.find(c => c.id === key)
              let name = (archiveColumn && archiveColumn.name) || ''
              // 处理文件类的内容更改
              changeObj[key] = this.handleFileContent(changeObj[key])
              content = `${content}${index === 0 ? '将' : ''}名称为：“${name}”字段的内容 ${changeObj[key].old === '' || changeObj[key].old === undefined ? '空' : changeObj[key].old} 改为 ${changeObj[key].new === '' || changeObj[key].new === undefined ? '空' : changeObj[key].new} ；`
            } else {
              // 表格的是异步，都会加在最后面
              asyncChildrenArray.push(this.getChildrenChangeContent({tableId: key, changeContent: changeObj[key]}))
            }
          })
        }
        return Promise.all(asyncChildrenArray).then(childrenContent => {
          childrenContent.forEach(c => {
            content = content + c
          })
          resolve(content)
        })
      })
    },
    getChildrenChangeContent (childrenTable) {
      return this.$axios.get(`/data-api/relations/${childrenTable.tableId}`)
        .then(res => {
          let tableName = res.data.name
          let content = ''
          let countNewData = 0
          childrenTable.changeContent.forEach(item => {
            let currentRowChangeContent = ''
            // 索引变更代表行数，处理行内容变化
            if (item.hasOwnProperty('index')) {
              // 处理一行内所有控件内容改变日志 一个item是一行， item内是一个个控件的归档字段
              Object.keys(item).forEach(c => {
                // 删除数据的时候会引起dataState的改变
                if (c === 'dataState' && item[c]['new'] === 'delete') {
                  currentRowChangeContent += `被删除 `
                } else if (c !== 'index') {
                  let col = res.data.columns.find(col => col.id === c)
                  let componentName = (col && col.name) || ''
                  currentRowChangeContent += `“${componentName}”内容 ${item[c]['old'] === undefined || item[c]['old'] === '' ? '空' : item[c]['old']} 改为 ${item[c]['new'] === '' || item[c]['new'] === undefined ? '空' : item[c]['new']} `
                }
              })
              if (currentRowChangeContent) {
                content += `${tableName}第${item['index']['new'] + 1}行${currentRowChangeContent}；`
              }
            } else if (item.old === undefined && item.new) {
              countNewData += 1
            }
          })
          if (countNewData) {
            content = `${content}${tableName}新增了${countNewData}条数据；`
          }
          return content
        })
    },
    discussPreviewImage (url) {
      this.currentPreviewImgUrlSrc = url
      this.currentPreviewImgUrl = [{url: url}]
    },
    // 讨论中的关闭图片预览
    closePreview () {
      this.currentPreviewImgUrlSrc = ''
      this.currentPreviewImgUrl = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/form/runtime/components/discussLogComponents/discussLogMixin.js